export const IMAGE_FILE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".heic",
  ".heif",
] as const;
export const PDF_FILE_EXTENSION = ".pdf" as const;
export const ACCEPTED_IMAGE_TYPES = { "image/*": [...IMAGE_FILE_EXTENSIONS] } as const;
export const ACCEPTED_PDF_TYPES = { "application/pdf": [PDF_FILE_EXTENSION] } as const;
export const XLSX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" as const;

export function getS3Url(key: string, bucket: string): string {
  return `https://${bucket}.s3.amazonaws.com/${key}`;
}

const IMAGE_EXTENSION_RE = /\.jpg$|\.jpeg$|\.png$|\.gif$|\.webp$|\.heic$|\.heif$/i;
const PDF_EXTENSION_RE = /\.pdf$/i;

export function isImageFile(
  value?: { type?: string | null; tempObjectUrl?: string | null } | null
): boolean {
  return (
    Boolean(value?.type?.includes("image")) ||
    Boolean(value?.tempObjectUrl && IMAGE_EXTENSION_RE.test(value.tempObjectUrl))
  );
}

export function isPdfFile(
  value?: { type?: string | null; tempObjectUrl?: string | null } | null
): boolean {
  return (
    Boolean(value?.type?.includes("pdf")) ||
    Boolean(value?.tempObjectUrl && PDF_EXTENSION_RE.test(value.tempObjectUrl))
  );
}
